export default "__VITE_ASSET__39d806f2__"